var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2595_140754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 14.7501C5.69036 14.7501 6.25 14.1904 6.25 13.5001C6.25 12.8097 5.69036 12.2501 5 12.2501C4.30964 12.2501 3.75 12.8097 3.75 13.5001C3.75 14.1904 4.30964 14.7501 5 14.7501Z",
    fill: "black",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 14.7501C12.1904 14.7501 12.75 14.1904 12.75 13.5001C12.75 12.8097 12.1904 12.2501 11.5 12.2501C10.8096 12.2501 10.25 12.8097 10.25 13.5001C10.25 14.1904 10.8096 14.7501 11.5 14.7501Z",
    fill: "black",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.39 11.2501H5.11C4.335 11.2501 3.64 10.7301 3.43 9.98009L1.36 2.75009H0.75C0.335 2.75009 0 2.41509 0 2.00009C0 1.58509 0.335 1.25009 0.75 1.25009H1.55C2.105 1.25009 2.6 1.62009 2.75 2.15509L3.205 3.75009H13.855C14.09 3.75009 14.31 3.86009 14.455 4.05009C14.6 4.24009 14.64 4.48009 14.575 4.71009L13.07 9.98509C12.855 10.7351 12.165 11.2551 11.385 11.2551L11.39 11.2501ZM5.115 9.75009H11.39C11.5 9.75009 11.6 9.67509 11.63 9.57009L12.865 5.25009H3.635L4.87 9.57009C4.9 9.67509 5 9.75009 5.11 9.75009H5.115Z",
    fill: "black",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2595_140754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping-cart.ae35153f.svg";
export { ForwardRef as ReactComponent };